module.exports = __webpack_public_path__ + "img/slide4.68d8ee48.png";